__turbopack_context__.v({
  "avatar": "Team-module__EqCvfq__avatar",
  "bio": "Team-module__EqCvfq__bio",
  "cardBody": "Team-module__EqCvfq__cardBody",
  "cardHeader": "Team-module__EqCvfq__cardHeader",
  "grid": "Team-module__EqCvfq__grid",
  "name": "Team-module__EqCvfq__name",
  "role": "Team-module__EqCvfq__role",
  "socialLink": "Team-module__EqCvfq__socialLink",
  "socialOverlay": "Team-module__EqCvfq__socialOverlay",
  "team": "Team-module__EqCvfq__team",
  "teamCard": "Team-module__EqCvfq__teamCard",
});
